import { useEffect, useState } from 'react';
import { Plus, Pencil } from 'lucide-react';
import { api } from '../api/client';
import { Avatar } from '../components/ui/Avatar';
import { Badge } from '../components/ui/Badge';
import { Modal } from '../components/ui/Modal';

const PERFIS = [
  { key: 'secretario', label: 'Secretário' },
  { key: 'comunicacao', label: 'Comunicação' },
  { key: 'admin', label: 'Administrador' },
];

export function AdminUsuariosPage() {
  const [usuarios, setUsuarios] = useState([]);
  const [secretarias, setSecretarias] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = async () => {
    const [u, s] = await Promise.all([api.get('/usuarios'), api.get('/secretarias')]);
    setUsuarios(u.usuarios);
    setSecretarias(s.secretarias);
  };
  useEffect(() => { load(); }, []);

  const salvar = async (form) => {
    if (form.id) {
      await api.patch(`/usuarios/${form.id}`, form);
    } else {
      await api.post('/usuarios', form);
    }
    setEditing(null);
    load();
  };

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Usuários</h1>
          <p className="page-subtitle">Gerencie quem acessa o sistema.</p>
        </div>
        <button className="btn btn-primary" onClick={() => setEditing({})}>
          <Plus size={16} /> Novo usuário
        </button>
      </div>

      <div className="card"><div className="card-body" style={{ padding: 0 }}>
        <div className="table-wrap">
          <table className="table">
            <thead>
              <tr><th>Nome</th><th>E-mail</th><th>Perfil</th><th>Secretaria</th><th>WhatsApp</th><th>Status</th><th></th></tr>
            </thead>
            <tbody>
              {usuarios.map((u) => (
                <tr key={u.id}>
                  <td><div className="row" style={{ gap: 8 }}><Avatar nome={u.nome} src={u.foto} size="sm" /><strong>{u.nome}</strong></div></td>
                  <td className="text-sm">{u.email}</td>
                  <td><Badge color={u.perfil === 'admin' ? 'purple' : u.perfil === 'comunicacao' ? 'info' : 'default'}>{PERFIS.find((p) => p.key === u.perfil)?.label}</Badge></td>
                  <td>{u.secretaria_nome || <span className="muted">—</span>}</td>
                  <td className="text-sm">{u.whatsapp || <span className="muted">—</span>}</td>
                  <td>{u.ativo ? <Badge color="success">Ativo</Badge> : <Badge color="danger">Inativo</Badge>}</td>
                  <td><button className="btn btn-ghost btn-sm" onClick={() => setEditing(u)}><Pencil size={14} /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div></div>

      {editing && (
        <UsuarioModal user={editing} secretarias={secretarias} onClose={() => setEditing(null)} onSave={salvar} />
      )}
    </div>
  );
}

function UsuarioModal({ user, secretarias, onClose, onSave }) {
  const [form, setForm] = useState({
    id: user.id,
    email: user.email || '',
    nome: user.nome || '',
    perfil: user.perfil || 'secretario',
    secretaria_id: user.secretaria_id || '',
    whatsapp: user.whatsapp || '',
    ativo: user.ativo ?? true,
  });
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await onSave({
        ...form,
        secretaria_id: form.secretaria_id ? parseInt(form.secretaria_id, 10) : null,
      });
    } finally { setSaving(false); }
  };

  return (
    <Modal open={true} onClose={onClose} title={user.id ? 'Editar usuário' : 'Novo usuário'}>
      <form onSubmit={submit} className="stack">
        <div className="field">
          <label>E-mail</label>
          <input className="input" type="email" required value={form.email} onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))} />
        </div>
        <div className="field">
          <label>Nome</label>
          <input className="input" required value={form.nome} onChange={(e) => setForm((f) => ({ ...f, nome: e.target.value }))} />
        </div>
        <div className="grid-2">
          <div className="field">
            <label>Perfil</label>
            <select className="select" value={form.perfil} onChange={(e) => setForm((f) => ({ ...f, perfil: e.target.value }))}>
              {PERFIS.map((p) => <option key={p.key} value={p.key}>{p.label}</option>)}
            </select>
          </div>
          <div className="field">
            <label>Secretaria</label>
            <select className="select" value={form.secretaria_id} onChange={(e) => setForm((f) => ({ ...f, secretaria_id: e.target.value }))}>
              <option value="">—</option>
              {secretarias.map((s) => <option key={s.id} value={s.id}>{s.nome}</option>)}
            </select>
          </div>
        </div>
        <div className="field">
          <label>WhatsApp</label>
          <input className="input" value={form.whatsapp} onChange={(e) => setForm((f) => ({ ...f, whatsapp: e.target.value }))} />
        </div>
        {user.id && (
          <label className="row" style={{ gap: 8 }}>
            <input type="checkbox" checked={form.ativo} onChange={(e) => setForm((f) => ({ ...f, ativo: e.target.checked }))} />
            Usuário ativo
          </label>
        )}
        <div className="row" style={{ justifyContent: 'flex-end', gap: 10 }}>
          <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
          <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Salvando...' : 'Salvar'}</button>
        </div>
      </form>
    </Modal>
  );
}
